import React from 'react';
import { Button } from '@mui/material';
import { ChipWithCopy } from 'new/elements/ChipWithCopy';
import LightningStatus from 'new/elements/LightningStatus';

import styles from './CredentialUsageItem.module.scss';

interface CredentialUsageItemProps {
  item: {
    id: number;
    flow_node_id: number;
    origin_node_id: number;
    owner_id: number;
    org_id: number;
    name: string;
    status: string;
  };
}

const goToFlow = (originNodeId: number) => {
  return (e) => {
    e.stopPropagation();
    window.open(`/integrate/flows/${originNodeId}/edit`, '_blank');
  };
};

export const CredentialUsageItem: React.FC<CredentialUsageItemProps> = ({ item }) => {
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <span className={styles.headerLeftTitle}>{item.name}</span>
        </div>
        <div className={styles.headerRight} />
      </div>

      {/* Content */}
      <div className={styles.content}>
        <div className={styles.contentLeft}>
          <ChipWithCopy toCopy={item.id.toString()}>ID: {item.id}</ChipWithCopy>
          <LightningStatus status={item.status} size="small" />
          <ChipWithCopy toCopy={item.origin_node_id.toString()}>
            FLOW ID: {item.origin_node_id}
          </ChipWithCopy>

          <div className={styles.previewFlowButtonContainer}>
            <Button
              variant="outlined"
              color="primary"
              size="small"
              role="button"
              onClick={goToFlow(item.origin_node_id)}
              data-testid="go-to-flow-button"
            >
              Go to Flow
            </Button>
          </div>
        </div>
        <div />
      </div>
    </div>
  );
};
